import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const ORGANIZATION_DASHBOARD = gql`
  query OrganizationDashboard(
    $organizationId: ID!
    $period: DashboardPeriod!
  ) {
    organizationDashboard(organizationId: $organizationId, period: $period) {
      currentPeriod {
        totalMembers
        activeMembers
        activeMembersPercentage
        totalSteps
        totalActivities
        totalKoinsEarned
        totalKoinsSpent
        totalChallengesActive
        totalChallengesUpcoming
        totalChallengesCompleted
        totalEventsActive
        totalEventsUpcoming
        totalEventsCompleted
        _suppressed
      }
      previousPeriod {
        totalMembers
        activeMembers
        activeMembersPercentage
        totalSteps
        totalActivities
        totalKoinsEarned
        totalKoinsSpent
        totalChallengesActive
        totalChallengesUpcoming
        totalChallengesCompleted
        totalEventsActive
        totalEventsUpcoming
        totalEventsCompleted
        _suppressed
      }
      trend {
        activeMembersTrend
        stepsTrend
        koinsEarnedTrend
        koinsSpentTrend
      }
      dailyBreakdown {
        date
        totalMembers
        activeMembers
        totalSteps
        koinsEarned
        koinsSpent
        _suppressed
      }
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const REFRESH_ORGANIZATION_STATS = gql`
  mutation RefreshOrganizationStats($organizationId: ID!) {
    refreshOrganizationStats(organizationId: $organizationId)
  }
`;
